export default __webpack_public_path__ + "static/media/CSRealCase2-moblie.d78cd51a.jpg";